import { render } from "./TestReview.vue?vue&type=template&id=5bcb7f64&scoped=true&ts=true"
import script from "./TestReview.vue?vue&type=script&lang=ts"
export * from "./TestReview.vue?vue&type=script&lang=ts"

import "./TestReview.vue?vue&type=style&index=0&id=5bcb7f64&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bcb7f64"]])

export default __exports__